import { CanActivateFn } from '@angular/router';
import { environment } from '../../../environments/environment.prod';

/**
 * Funktionaler Guard: Aktivierung nur in der Entwicklungsumgebung erlaubt.
 */
export const developmentGuard: CanActivateFn = () => !environment.production;